import styled from 'styled-components';
import ReactPlayer from 'react-player'

export const Content = styled.div` /* max-width: 80%; */
display: grid;
/* max-height: 85vh; */
/* max-height: 90vh; */
/* min-height: 81vh; */
/* max-width: 85vw; */
border: 1px solid black;
grid-gap: 1vw;
grid-template-columns: 1fr 1fr ;
/* grid-template-rows: 1fr 5fr 0.5fr; */
grid-template-areas:
"title title"
"img info"
"tech tech" ;
/* background: orange; */
border: 1px solid white;
/* align-content: center;
align-items: center;
align-self: center; */
margin: auto;
margin-bottom: 3rem;
padding: 20px;

h1{
  grid-area: title;
  justify-self: center;
  align-self: flex-end;
}

@media screen and (max-width: 1200px){
grid-template-columns: 1fr;
/* grid-template-rows: 0.5fr 2fr 5fr 0.5fr; */
/* grid-template-rows: 0fr 0fr 1fr 0.5fr; */
grid-template-areas: 
"title"
"img"
"info"
"tech";
/* max-height: max-content; */
font-size: 40px;
}

/* background: rgba( 95, 3, 103, 0.10 ); */
/* box-shadow: 0 8px 32px 0 rgba( 31, 38, 135, 0.37 ); */
backdrop-filter: blur( 20.0px );
-webkit-backdrop-filter: blur( 20.0px );
border-radius: 10px;
border: 1px solid rgba( 255, 255, 255, 0.18 );
`;

export const Media = styled.div`
/* border: 1px solid white; */
/* width: 100%;
height: 100%; */
grid-area: img;
/* margin: auto; */
align-self: center;
justify-self: center;
text-align-last: center;
img{
  justify-self: center;
}

`;
export const StyledReactPlayer = styled(ReactPlayer)`
@media screen and (max-width: 1200px){
/* height: fit-content !important;
width: 100vw !important;
justify-self: center;
position: absolute;
top: 12%;
right: -8% */

height:max-content !important;
width: auto !important;
}

`;

export const Details = styled.div`
//para la width usar window.mobileCheck = function() {
  /* let check = false;
  (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|b≈ada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
  return check;
}; */
/* max-width: 47.5vw; */
width: 100%;
/* border: 1px   solid white; */
/* grid-area: info; */
height: 100%;
display: flex;
flex-direction: column;
justify-items: center;
/* grid-template: 1fr 3fr 1fr 1fr /1fr; */


/* background: rgba( 0, 0, 0, 0.20 ); */
border: none;
grid-area: tech;
margin-bottom: 1rem;

h1{
  align-self: center;
}

`;
export const TextArea = styled.div`
padding: 2vw;
grid-area: info;
align-self: baseline;
height:fit-content;
/* border: 1px solid white; */
`;

export const GLink = styled.h2`
align-self: center;
a{
  color: purple
}
`;

export const Arrow = styled.div`
/* margin: ${props => props.position === "left" ? "0 1rem 0 0" : "0 0 0 1rem"}; */
img{
  height: 5vh;
  width: auto;
  
  @media screen and (max-width: 1200px){
    position: fixed;
    opacity: 0.2;
    z-index: 300;
    height: 10vw;
    left: ${props => props.position === "left" ? "-3%" : "90%"};;
    top: 50%;
  }
}
`;

export const TechArea = styled.div`
display: flex;
background: none;
flex-shrink: 0;
flex-flow: row wrap;
align-items: center;
justify-content: center;
padding: 1rem;
img{
  height: 5rem;
  width: auto;
  margin: 5px;
}
@media screen and (max-width: 1200px){
img{
  height: 20vw;
  margin: 1vw;
}
}
`;

export const Div = styled.div`
display: flex; 
/* flex-direction: column; */
width: 98vw;
height: fit-content;
align-items: center;
align-self: center;
`;